import { render, staticRenderFns } from "./approved-messages-list.vue?vue&type=template&id=60a94b78"
import script from "./approved-messages-list.vue?vue&type=script&lang=js"
export * from "./approved-messages-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60a94b78')) {
      api.createRecord('60a94b78', component.options)
    } else {
      api.reload('60a94b78', component.options)
    }
    module.hot.accept("./approved-messages-list.vue?vue&type=template&id=60a94b78", function () {
      api.rerender('60a94b78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/shared/message-control/approved-messages-list.vue"
export default component.exports